var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPppz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M9.19 7.23c0-1.71-1.39-3.09-3.09-3.09S3.01 5.53 3.01 7.23v2.59h6.15l.03-2.59zM9.15 9.82v21.12h13.43M29.4 13.2v2.07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M6.31 4.14h20c1.71 0 3.09 1.39 3.09 3.09v1.01M29.4 26.46v9.23c0 1.56-1.27 2.83-2.83 2.83s-2.83-1.27-2.83-2.83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M39.52 25.9c0-5.59-4.53-10.12-10.12-10.12S19.28 20.31 19.28 25.9h20.24zM14.87 10.15h8.87"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 14.87,
    cy: 15.15,
    r: 1.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPppz);
export default __webpack_public_path__ + "static/media/PPPZ.ee36a12a46b79ff75a1d29566a35cce3.svg";
export { ForwardRef as ReactComponent };